// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#Cart .cart-title{display:inline-flex;align-items:center;gap:.5rem;font-size:1.8rem;white-space:nowrap}#Cart .cart-count-badge{border:1px solid currentColor;background-color:#fff!important;color:#007ac2;font-size:.85rem;line-height:1}#Cart .custom-control-label{width:100%!important}@media(max-width:799.98px){#Cart .cart-title{font-size:1.6rem}}", ""]);
// Exports
module.exports = exports;
